export default "__VITE_ASSET__goE5$_7F__"